import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import logo from '../../../../assets/logo.png'; // Import the logo image

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#ffffff', // Background set to white
                borderRadius: 2,
                padding: '30px 20px',
                textAlign: 'center',
                marginTop: '60px', // Added more top margin
                color: '#333', // Reverted text color to a darker shade
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '15px', // Adjusted margin
                }}
            >
                {/* Logo */}
                <img
                    src={logo} // Path to the logo
                    alt="Yamba Africa Logo"
                    style={{ width: '120px', height: 'auto' }} // Adjust the size of the logo
                />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' }, // Stack vertically on smaller screens, horizontal on larger
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: 1, md: 3 }, // Smaller gap on mobile, larger on desktop
                    marginBottom: '12px', // Adjusted margin
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        color: '#666', // Lighter dark shade
                        fontSize: '12px', // Smaller font size
                    }}
                >
                    © {new Date().getFullYear()} Yamba Africa. All Rights Reserved.
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1, // Slightly reduced gap for a compact layout
                    }}
                >
                    <Link 
                        href="/privacy-policy" 
                        sx={{ 
                            color: '#333', 
                            textDecoration: 'none', 
                            fontSize: '12px', 
                            '&:hover': { 
                                color: '#555',
                                textDecoration: 'underline' // Added underline on hover
                            } 
                        }}
                    >
                        Privacy Policy
                    </Link>
                    <Typography variant="body2" sx={{ color: '#333' }}>|</Typography> {/* Vertical line separator */}
                    <Link 
                        href="/terms-of-use" 
                        sx={{ 
                            color: '#333', 
                            textDecoration: 'none', 
                            fontSize: '12px', 
                            '&:hover': { 
                                color: '#555',
                                textDecoration: 'underline' // Added underline on hover
                            } 
                        }}
                    >
                        Terms of Service
                    </Link>
                </Box>
            </Box>
        </Box>
    );
};

export default Footer;
